import getBasePath from '../functions/api-resource';

const basePath = getBasePath('workflow', 'configuracao');

const configuracaoActions = {
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
